module.exports = __webpack_public_path__ + "media/applicants/cbs-bfb736e4.png";